import styled from 'styled-components'

export const Container = styled.div`
  text-align: center;
  padding: 4rem 0;
`
